export const OneLoginURL = 'https://casestack.onelogin.com'
export const UrlApi = 'https://no8feqw4vd.execute-api.us-west-2.amazonaws.com/prod'